async function exportPipeline(data, EXPORTED_COLS, EXPORTED_HEADERNAME, fileName) {
  const XLSX = await import('xlsx');
  console.log('data', data);
  const book = XLSX.utils.book_new();
  XLSX.utils.sheet_add_json(book, data, {
    origin: 'A2',
    skipHeader: true,
    header: EXPORTED_COLS,
  });
  XLSX.utils.sheet_add_aoa(book, [EXPORTED_HEADERNAME]);
  XLSX.utils.book_append_sheet(book, book, fileName);
  XLSX.writeFile(book, `${fileName}.xlsx`);
}

export { exportPipeline };
